import { Page as Component } from "~/components/specifics/deals/[id]/completion_reports/Page";

export function Page() {
	return <Component />;
}
